import { isEligible } from '@wix/ambassador-premium-features-manager-v1-feature/http';
import { HttpClient } from '@wix/http-client';
import type { IsEligibleResponse } from '@wix/ambassador-premium-features-manager-v1-feature/types';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import experiment from 'experiment';

export interface ExecuteWithPremiumCheckProps {
  onSuccess: (id?: string) => void;
  platformAPI: EditorPlatformHostIntegrationAPI;
  appDefinitionId?: string;
  metaSiteId: string;
  premiumFeatureName?: string;
}
export const executeWithPremiumCheck = async ({
  onSuccess,
  platformAPI,
  appDefinitionId,
  metaSiteId,
  premiumFeatureName,
}: ExecuteWithPremiumCheckProps) => {
  const httpClient = new HttpClient();
  const shouldCheckPremiumFeature = experiment.isOpen(
    'se_premiumActionsInPagesPanel',
  );
  if (!premiumFeatureName || !shouldCheckPremiumFeature) {
    onSuccess();
    return;
  }

  try {
    const response = await httpClient.request<IsEligibleResponse>(
      isEligible({
        uniqueName: premiumFeatureName,
        msid: metaSiteId,
        eligibleToIncrementBy: 1,
      }),
    );

    if (response?.data?.isEligible) {
      onSuccess();
    } else {
      platformAPI.panels.upgradeSiteConfirmation.open(
        appDefinitionId,
        premiumFeatureName,
      );
    }
  } catch (error) {
    console.error(
      `Failed to check eligibility for feature: ${premiumFeatureName}`,
      error,
    );
  }
};
